import React from 'react'

import { Stack, type StackProps } from '~/components/elements/Stack'

export type HStackProps = Omit<StackProps, 'direction'> & {
  reverse?: boolean
}

export const HStack = React.forwardRef<HTMLDivElement, HStackProps>(
  (
    {
      'data-testid': dataTestId = 'components-elements-h-stack',
      reverse = false,
      ...rest
    },
    ref,
  ) => (
    <Stack
      ref={ref}
      data-testid={dataTestId}
      direction={reverse ? 'row-reverse' : 'row'}
      {...rest}
    />
  ),
)
